import React, { memo } from 'react';
import { Slider } from 'antd';
import { ReactComponent as Image } from '../../../assets/icons/image.svg';

interface ISliderProps {
  imageTransparency: number;
  handleImageTransparency: (value: number) => void;
}

const TransparencySlider: React.FC<ISliderProps> = ({
  imageTransparency,
  handleImageTransparency,
}) => (
  <div style={{
    display: 'flex', flexDirection: 'column', gap: '16px',
  }}
  >
    <span style={{ fontWeight: 600, fontSize: '16px', color: '#4E4F52' }}>Transparency</span>
    <div style={{
      display: 'flex', flexDirection: 'column', width: '95%', gap: '16px',
    }}
    >
      <div>
        <div style={{
          gap: '4px',
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <Image style={{ width: 16, height: 16 }} />
          <span>Image</span>
        </div>
        <Slider
          className="custom-slider"
          min={0}
          max={0.9}
          step={0.05}
          value={imageTransparency}
          onChange={handleImageTransparency}
        />
      </div>
    </div>
  </div>
);

export default memo(TransparencySlider);
